import { supabase } from '../lib/supabase';

export const projectNoteService = {
  async getByProject(projectId) {
    const { data, error } = await supabase?.from('project_notes')?.select(`
        *,
        created_by_profile:user_profiles!project_notes_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_notes_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.eq('project_id', projectId)?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async create(projectId, title, content, userId) {
    const { data, error } = await supabase?.from('project_notes')?.insert({ project_id: projectId, title, content, created_by: userId, updated_by: userId })?.select(`
        *,
        created_by_profile:user_profiles!project_notes_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_notes_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.single();
    if (error) throw error;
    return data;
  },

  async update(noteId, title, content, userId) {
    const { data, error } = await supabase?.from('project_notes')?.update({ title, content, updated_by: userId })?.eq('id', noteId)?.select(`
        *,
        created_by_profile:user_profiles!project_notes_created_by_fkey(id, full_name, first_name, last_name, email),
        updated_by_profile:user_profiles!project_notes_updated_by_fkey(id, full_name, first_name, last_name, email)
      `)?.single();
    if (error) throw error;
    return data;
  },

  async delete(noteId) {
    const { error } = await supabase?.from('project_notes')?.delete()?.eq('id', noteId);
    if (error) throw error;
  },
};
